<template>
  <div class="SolutionPages">
    
    <div class="solutionBackground">
      <Header :activedUrl="activedUrl" :background="background"></Header>
      <div class="bigTitle titImg" :title="$t('solution.pageTitle')">{{ $t('solution.pageTitle') }}</div>
      <div class="bigTitle titImg h5Title" :title="$t('solution.pageTitle')" v-html="$t('solution.pageTitleH5')"></div>
      
      <div class="w1200 toSeeServes">
        <div v-for="(item,i) in toSeeServe" :key="i" class="serveItem" :class="{'yellowAct':item.title == currentServe.title}"  @click="handerIndex(i)">
          <div class="item-title">
            {{ item.title }}
          </div>
          <div class="item-detailTit">
            {{ item.detailTit }}
          </div>
        </div>
      </div>
      
      <div class="toSeeTab-box">
        <div class="toSeeTab">
          <div v-for="(item,i) in toSeeServe" :key="'see'+i" class="tabItem" :class="{'yellowAct':item.title == currentServe.title}"  @click="handerIndex(i)">
            {{item.title }}
          </div>
        </div>
      </div>
      
      <div class="currentServes">
        <div class="currentLeft">
          <div class="currentTit">{{ currentServe.title }}</div>
          <div class="currentDes">{{ currentServe.detailDes }}</div>
          <div><span class="free" @click="toRegister">{{ $t('solution.freeTrial') }}</span></div>
        </div>
        <div class="currentRight">
          <img :src="currentServe.detailImg" />
        </div>
      </div>
    </div>

    <div class="criticalData">
      <div class="bigTitle" :title="$t('solution.painPointTitle')">{{ $t('solution.painPointTitle') }}</div>
      <div class="critical-main">
        <div class="critical-item color0" :class="margTop1" >
          <img src="@a/images/solution/yellow.png" alt="小五出海"  class="solutions" />
        </div>
        <div class="critical-item color1" :class="margTop1" id="color1" >
          <div class="cri-tit">{{ currentServe.list[0].title }}</div>
          <div class="cri-des">{{ currentServe.list[0].des }}</div>
        </div>
        <div class="critical-item color2" :class="margTop2" id="color2">
          <div class="cri-tit">{{ currentServe.list[1].title }}</div>
          <div class="cri-des">{{ currentServe.list[1].des }}</div>
        </div>
        <div class="critical-item color3" :class="margTop2">
          <img src="@a/images/solution/blue.png" alt="小五出海"  class="solutions" />
        </div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Header from '@v/header/index'
import Foot from '@v/foot/index'
import { isMobile } from '@/utils/index'
export default {
  name: 'SolutionPages',
  props: {},
  components: {
    Header, Foot,
  },
  data() {
    return {
      activedUrl:'solution',
      background:'solution',
      serviceMedia:[
        { icon:require('@a/images/header/header.png'), detailIcon:require('@a/images/header/header.png'), detailImg:require('@a/images/solution/right2.png') },
        { icon:require('@a/images/header/header.png'), detailIcon:require('@a/images/header/header.png'), detailImg:require('@a/images/solution/right1.png') },
        { icon:require('@a/images/header/header.png'), detailIcon:require('@a/images/header/header.png'), detailImg:require('@a/images/solution/right3.png') },
        { icon:require('@a/images/header/header.png'), detailIcon:require('@a/images/header/header.png'), detailImg:require('@a/images/solution/right4.png') },
      ],
      intervalId: null,
      indexs:0,
      scrollTop:0,
      margTop1:'',
      margTop2:'',
      isH5:false,
    }
  },
  watch: {},
  computed: {
    toSeeServe() {
      const list = this.$t('solution.services')
      return this.serviceMedia.map((media, i) => ({
        ...media,
        title: list[i].title,
        detailTit: list[i].detailTit,
        detailDes: list[i].detailDes,
        list: list[i].list,
      }))
    },
    currentServe(){
      return this.toSeeServe[this.indexs]
    }
  },
  methods: {
    checkPosition() {
      this.scrollTop = document.documentElement
        ? document.documentElement.scrollTop
        : document.body.scrollTop

        const screenHeight = window.innerHeight;
        console.log('tops::', this.scrollTop+ screenHeight)
        if (!this.isH5 ) {
          if( this.scrollTop + screenHeight > 1300){
            this.margTop1= 'marginTop'
          }
          if(  this.scrollTop + screenHeight > 1780){
            this.margTop2= 'marginTop'
          }
        }
        if (this.isH5 ){
          var color1 = document.getElementById('color1')
          var color2 = document.getElementById('color2')
          console.log('color::',color1.offsetTop)
          if( this.scrollTop + screenHeight > color1.offsetTop+60){
            this.margTop1= 'marginTop'
          }
          if(  this.scrollTop + screenHeight > color2.offsetTop+60){
            this.margTop2= 'marginTop'
          }
        }
        
    },
    startScroll() {
      if (this.intervalId) return;
      this.intervalId = setInterval(() => {
        
        if (this.indexs ==3) {
          this.indexs = 0
        } else {
          this.indexs = this.indexs +1
        }
      }, 10000); // 滚动速度，可以根据需要调整
      
    },
    pauseScroll() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    resumeScroll() {
      this.startScroll();
    },
    handerIndex(i){
      this.indexs = i
      this.margTop1= ''
      this.margTop2=''
    },
    handerServe(value){
      this.currentServe = this.toSeeServe[value]
    },
    toRegister(){
      if(isMobile()){
        window.location.href = '/erwei'
      } else {
       window.location.href = 'https://cr.xiaowutube.com/register'
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.checkPosition()
    })
    this.handerIndex(0)
    this.isH5 = isMobile()
   

  },
  filters: {},
}
</script>

<style scoped lang="scss">
.SolutionPages{
  overflow-x: scroll;
  .solutionBackground{
    padding-top: 70px;
    background-image:  url('@a/images/solution/solutionbk.png');
    background-size: 100% 100%;
  }

  .toSeeServes{
    width: 1160px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .serveItem{
      flex: 0 0 275px;
      height: 125px;
      border-radius: 14px;
      padding: 20px 24px;
      border: 1px solid #EEEEEE;
      cursor: pointer;
      margin-bottom: 40px;
      .item-title{
        font-family: AlibabaPuHuiTiM;
        font-size: 24px;
        color: rgba(0,0,0,0.8);
        line-height: 33px;
        margin-bottom: 8px;
      }
      .item-detailTit{
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0,0,0,0.4);
        line-height: 22px;
      }
    }
    .yellowAct{
      border-radius: 14px;
      border: 1px solid transparent;
      background-image:  url('@a/images/solution/car.png');
      background-size: 100% 100%;
      .item-title{
        color: #FB9716;
      }
    }
  }
  .toSeeTab-box{
    display: none;
  }
  .currentServes{
    width: 1160px;
    height: 366px;
    background: #FFFFFF;
    box-shadow: 0px 2px 80px 0px rgba(0,0,0,0.04);
    border-radius: 20px;
    margin: 0 auto;
    padding: 50px 80px 40px 80px;
    display: flex;
    justify-content: space-between;
    .currentLeft{
      flex:00 500px;
    }
    .currentRight{
      img{
        display: block;
        width: 360px;
        height: 234px;
      }
    }
    .currentTit{
      font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
      font-weight: normal;
      font-size: 32px;
      color: rgba(0,0,0,0.8);
      line-height: 44px;
      margin-bottom: 30px;
    }
    .currentDes{
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #626262;
      line-height: 22px;
      margin-bottom: 30px;
    }
    .free{
      display: inline-block;
      text-align: center;
      font-family: AlibabaPuHuiTiM;
      font-size: 16px;
      color: rgba(0,0,0,0.8);
      cursor: pointer;
      width: 140px;
      height: 40px;
      line-height: 40px;
      background: linear-gradient( 48deg, #FFDD2F 0%, #FFA50C 15%, #FF673F 85%, #FF4F91 100%);
      border-radius: 6px;
      color: #fff;
    }
    .free:hover{
      background: linear-gradient( 48deg, #FFDD2F 0%, #FFA50C 5%, #FF673F 55%, #FF4F91 100%);
    }
  }
    
  .criticalData{
    width: 900px;
    margin: 0 auto;
    margin-bottom: 90px;
    padding-top: 20px;
    .critical-main{
      display: flex;
      justify-content:space-between;
      flex-wrap: wrap;
      .critical-item{
        flex: 0 0 500px;
        border-radius: 16px;
        padding-top: 100px;
        padding-bottom: 40px;
        margin-top: 140px;
        background: url('@a/images/solution/colorBk.png') right top no-repeat;
        background-size: 80px 80px;
        transition: all 0.5s;
        img.solutions{
          display: inline-block;
          width: 230px;
          height: 270px;
        }
        .cri-tit{
          font-family: AlibabaPuHuiTiM;
          font-size: 24px;
          color: rgba(0,0,0,0.8);
          line-height: 33px;
          margin-bottom: 20px;
          margin-top: 8px;
        }
        .cri-des{
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          font-size: 18px;
          color: rgba(0,0,0,0.6);
          line-height: 25px;
        }
        
      }
     
      .color0{
        padding-top: 60px;
        flex: 0 0 400px;
      }
      .color1{
        position: relative;
        .cri-tit{
          color: #FB9716;
        }
      }
      .color1::after{
        content: "";
        position: absolute;
        right: -500px;
        top: 0;
        width: 539px;
        height: 449px;
        background: linear-gradient( 163deg, #E8F6FF 0%, #88C9FF 100%);
        opacity: 0.18;
        filter: blur(50px);
      }
      .color2{
        position: relative;
        .cri-tit{
          color: #3988FF;
        }
      }
      .color2::after{
        content: "";
        position: absolute;
        left: -500px;
        top: 0;
        width: 502px;
        height: 449px;
        background: linear-gradient( 207deg, #FFFDEC 0%, #FFFCEA 19%, #FFEB88 100%);
        opacity: 0.16;
        filter: blur(50px);
      }
      .color3{
        flex: 0 0 400px;
        padding-top: 60px;
        padding-left: 160px;
      }
      .color5{
        .cri-tit{
          color: #00CEA9;
        }
      }
      .marginTop{
        margin-top: -10px;
      }
      
    }
   
  } 
  .h5Title{
   display: none;
  } 
  .titImg::after{
    content: "";
    position: absolute;
    left:50%;
    bottom: -6px;
    background: url('@a/images/solution/titImg.png') center no-repeat;
    width: 204px;
    height: 18px;
    background-size: 100%;
    margin-left: 15px;
  }

  
}

@media screen and (max-width: 750px) {
  .solutionBackground{
    overflow: hidden;
  }
  .SolutionPages {
    .bigTitle{
      height: auto;
    }
    .titImg{
      display: none;
    }
    .h5Title{
      display: block;
      width: 390px;
      height: auto;
      line-height: 40px;
      margin: 0 auto;
      margin-bottom: 40px;
      margin-top: 60px;
    } 
    .toSeeServes {
      display: none;
      .serveItem {
        flex: 0 0 275px;
        height: auto;
        border-radius: 14px;
        padding: 15px 14px 15px;
        border: 1px solid #EEEEEE;
        cursor: pointer;
        margin-bottom: 40px;
        margin: 10px 20px;
      }
    }
    .toSeeTab-box{
      width: 100%;
      overflow-x: auto;
      display: block;
      -ms-overflow-style: none;  /* IE 10+ */
       scrollbar-width: none;  
     
    }
    .toSeeTab-box::-webkit-scrollbar {
      display: none;
    }

    .toSeeTab{
      margin: 0 auto;
      padding: 0 10px;
      display: block;
      white-space: nowrap;
      margin-bottom: 20px;
      margin-top: 20px;
      width: 510px;
      //  width: auto;
      border-bottom: 1px solid rgba(31,35,41,.15);
      .tabItem{
        display: inline-block;
        padding: 0 10px;
        font-family: AlibabaPuHuiTiM;
        font-size: 18px;
        color: rgba(0,0,0,0.8);
        line-height: 50px;
        border-bottom: 2px solid transparent;
        margin-right: 10px;
      }
      .yellowAct{
        color: #FB9716;
        border-bottom: 2px solid #FB9716;
      }
    }
    .currentServes{
      width: auto;
      height: auto;
      background: #FFFFFF;
      box-shadow: 0px 2px 80px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      margin: 0 auto;
      padding: 20px 20px 10px 20px;
      display: block;
      margin: 0px 20px;
      justify-content: space-between;
      .currentTit{
        font-size: 18px;
        margin-bottom: 0px;
      }
      .currentDes{
        font-size: 14px;
      }
      .currentRight{
        margin-top: 20px;
        text-align: center;
        img {
          display: inline-block;
          width:90%;
          height: auto;
        }
      }
    }

    .criticalData {
      width: auto;
      margin: 0 auto;
      margin-bottom: 10px;
      .color0, .color3{
        display: none;
      }
      .critical-main{
        display: block;
        .critical-item{
          flex: 0 0 500px;
          border-radius: 16px;
          padding-top: 0px;
          padding-bottom: 40px;
          margin: 140px 20px 0px;
          .cri-tit{
            font-size: 22px;
          }
          .cri-des{
            font-size: 16px;
          }
         
        }
        .color1::after{
          display: none;
        }
        .marginTop{
          margin-top: 0px;
        }
      } 
      
    }

    .titImg::after{
      content: "";
      position: absolute;
      left: auto;
      right: 89px;
      bottom: -8px;
      background: url('@a/images/solution/titImg.png') center no-repeat;
      width: 164px;
      height: 18px;
      background-size: 100%;
      margin-left: 0px;
    }

  }
  
  
}

</style>
